import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const IssuingPolicy = lazy(() => import('@pages/landing/IssuingPolicy'));
export const IssuingPolicyRoutes: RouteObject[] = [
  {
    path: '/issuing-policy',
    element: (
      <React.Suspense>
        <IssuingPolicy />
      </React.Suspense>
    ),
  },
];
